import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductConfig } from '../@types/context/product-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactAxoSeConfig } from './presets/contact-axo-se.config';
import { insuranceMypageSe } from './presets/insurance-mypage.config';
import { globalSe } from './presets/global-se.config';
import { myPageCcd2SeOptions } from './presets/mypage-ccd2-se.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { productConfigLimited } from './presets/product-config.preset';
import { organisationAxoSeConfig } from './presets/organisation-axo-se.config';
import { serviceTrustpilotAxoSeConfig } from './presets/service-trustpilot-axo-se.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansSeConfig } from './presets/unsecured-loans-se.config';

export const global: GlobalConfig = {
  brand: 'axofinans.se',
  ...globalSe,
};

export const site: SiteConfig = {
  domain: 'axofinans.se',
  name: 'Axo Finans',
  theme: {
    name: 'axo-finans',
    brand: 'axo-finans',
  },
  path: {
    loansApply: '/soknad/forbrukslan',
    loansPreForm: '/lana-pengar',
    // OneForm (SE). `identifiering` mirrors FI's `tunnistautuminen` — the
    // preflight is an identification step, not a NO-style pre-check.
    oneFormPreflight: '/ansokan/identifiering',
    oneFormApply: '/ansokan/lan',
    oneFormRecommendations: '/ansokan/lan/rekommendationer',
    mypage: 'https://mypage.axofinans.se',
    insurance: '/soknad/forsakring',
    // site-one mypage paths (path-based, not subdomain)
    mypageOverview: '/mina-sidor',
    mypageLoans: '/mina-sidor/lan',
    ...insuranceMypageSe,
  },
  ...organisationAxoSeConfig,
  ...contactAxoSeConfig,
  services: {
    cms: {
      provider: 'prepr',
    },
    cookieConsentManager: {
      provider: 'cookieyes',
      cookieyes: {
        siteId: {
          production: '9600f2cb475a5864d7235a07719106f9',
          staging: '53a3b4e6a5b46b3808ea17f109ccf4ea',
        },
        scriptStrategy: 'lazyOnload',
      },
    },
    // Live TrustScore as review-snippet stars in the page JSON-LD (MVF-132).
    trustpilot: { ...serviceTrustpilotAxoSeConfig, reviewSnippet: true },
    gtm: 'GTM-MF2KR9',
    ga: 'G-XWKXZNXVLW',
    // SPIKE: defer GTM off the critical path (see axolaina.fi). Measure first.
    gtmScriptStrategy: 'lazyOnload',
    launchDarkly: {
      enabled: true,
      anonymousExperimentsEnabled: false,
    },
    statsig: {
      enabled: true,
      autoCapture: false,
      sessionReplay: false,
      proxyEnabled: true,
    },
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansSeConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const myPage: MyPageConfig = {
  options: {
    hasHighCostWarning: true,
    ...myPageOffersConfig,
    ...myPageCcd2SeOptions,
  },
};

export const product: ProductConfig = productConfigLimited;
